import gsap from 'gsap';
import MorphSVGPlugin from 'gsap/MorphSVGPlugin';
import React, { createRef, useEffect } from 'react';
import styled from 'styled-components';
import { Icon } from '../';
gsap.registerPlugin(MorphSVGPlugin);
const Wrapper = styled.div `
  display: flex;
`;
export const IconLogout = (props) => {
    const wrapperRef = createRef();
    const triggerDone = () => {
        if (props.onDone) {
            props.onDone();
        }
    };
    useEffect(() => {
        if (props.running) {
            const arrow = wrapperRef.current?.querySelector('svg g path:first-child');
            const door = wrapperRef.current?.querySelector('svg g path:last-child');
            const knob = wrapperRef.current?.querySelector('svg circle');
            if (arrow && door && knob) {
                gsap.to(arrow, {
                    keyframes: [
                        {
                            x: 1.5,
                            duration: 0.1,
                        },
                        {
                            x: 0,
                            duration: 0.3,
                            delay: 0.05,
                        },
                    ],
                });
                gsap.to(knob, {
                    keyframes: [
                        {
                            x: 3,
                            scale: 0.75,
                            duration: 0.1,
                        },
                        {
                            x: 0,
                            scale: 1,
                            duration: 0.3,
                            delay: 0.05,
                        },
                    ],
                });
                gsap.to(door, {
                    keyframes: [
                        {
                            morphSVG: 'M3 6C3 4.89543 3.89543 4 5 4H11C12.1046 4 13 4.89543 13 6V14C13 15.1046 12.1046 16 11 16H5C3.89543 16 3 15.1046 3 14V6Z',
                            duration: 0.1,
                        },
                        {
                            morphSVG: 'M3 5.53656C3 4.63045 3.60917 3.83756 4.48467 3.60409L7.98467 2.67075C9.25437 2.33217 10.5 3.28916 10.5 4.60322V15.3968C10.5 16.7108 9.25437 17.6678 7.98467 17.3292L4.48468 16.3959C3.60917 16.1624 3 15.3695 3 14.4634V5.53656Z',
                            duration: 0.3,
                            delay: 0.05,
                            onComplete: () => {
                                triggerDone();
                            },
                        },
                    ],
                });
            }
        }
    }, [props.running]);
    return (React.createElement(Wrapper, { className: props.className, ref: wrapperRef },
        React.createElement(Icon.Logout, null)));
};
//# sourceMappingURL=Logout.js.map